import { MenuProps } from 'antd/es/menu';
import { Button, Col, Dropdown, message, Row, Tooltip, Typography } from 'antd';
import Title from 'antd/es/typography/Title';
import React from 'react';
import './DocumentItem.scss';
import useLibrary from '@hooks/useLibrary';
import { base64toFile } from '@modules/OnlineLibrary/helpers/base64toFile';
import useAuth from '@hooks/useAuth';
import { getAccess } from '@modules/OnlineLibrary/helpers/getAccess';
import api from '@modules/OnlineLibrary/services/api';
import { getAuthUserId } from '@modules/OnlineLibrary/helpers/getAuthUserId';

const { Text } = Typography;

interface IPropsDocumentItem {
  title: string;
  uuid: string;
  deleteDocument: (e) => void;
  showInfo: () => void;
  extension: string;
}

const DocumentItem = ({ title, uuid, deleteDocument, showInfo, extension }: IPropsDocumentItem) => {
  const { setIsDocument, setCurrentFileUuid } = useLibrary();
  const { user } = useAuth();

  const downloadDocument = async (e) => {
    e.stopPropagation();
    try {
      const response = await api.downloadDocument(uuid);
      const data = response.data.content.slice(2, -1);
      const file = base64toFile(data, response.data.filename, response.headers['content-type']);

      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(file);
      downloadLink.download = response.data.filename;
      downloadLink.click();
      URL.revokeObjectURL(downloadLink.href);
    } catch (e) {
      message.error('Не удалось скачать файл');
    }
  };

  const readDocument = async () => {
    const userId = getAuthUserId(user);

    if (!userId) {
      message.error('Не удалось определить пользователя');
      return;
    }

    try {
      const response = await api.readDocument(uuid, userId);
      const contentType = encodeURIComponent(
        response.headers['content-type'] || ''
      );
      window.open(
        `/read-file-library?uuid=${uuid}&contentType=${contentType}&user_id=${userId}`,
        '_blank'
      );
    } catch (e) {
      message.error('Не удалось совершить предпросмотр документа');
    }
  };

  const onDeleteDocument = (e) => {
    setIsDocument(true);
    setCurrentFileUuid(uuid);
    deleteDocument(e);
  };

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <a onClick={(e) => downloadDocument(e)} className="d-flex align-center">
          <i className="download-dropdown-online-library"/>
          <Text className="ml-1">Скачать</Text>
        </a>
      ),
    },
    getAccess('create', user) || getAccess('update', user) ? {
      key: '2',
      label: (
        <a
          className="d-flex align-center"
          onClick={(e) => {
            e.stopPropagation();
            setIsDocument(true);
            setCurrentFileUuid(uuid)
            showInfo();
          }}
        >
          <i className="info-dropdown-online-library"/>
          <Text className="ml-1">Сведения</Text>
        </a>
      ),
    } : null,
    getAccess('delete', user) ? {
      type: 'divider',
    } : null,
    getAccess('delete', user) ? {
      key: '3',
      label: (
        <a onClick={(e) => onDeleteDocument(e)} className="d-flex align-center">
          <i className="delete-dropdown-online-library"/>
          <Text className="ml-1">Удалить</Text>
        </a>
      ),
    } : null,
  ];

  return (
    <Col xs={24} lg={6}>
      <Row className="item-folder-online-library dropdown-index" onClick={readDocument}>
        <Row className="d-flex justify-space-between width">
          <Row className="d-flex align-start justify-center">
            <i className="main-document-icon-online-library"/>
            <Title level={4} className="filename-online-library">{extension}</Title>
          </Row>
          <Dropdown menu={{ items }} placement="bottom">
            <Button className="dropdown-online-library" onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}>
              &middot;&middot;&middot;
            </Button>
          </Dropdown>
        </Row>
        <Row className="d-flex justify-space-between width">
          <Tooltip title={title} placement="bottom">
            <Title level={5} className="title-document-online-library">{title}</Title>
          </Tooltip>
        </Row>
      </Row>
    </Col>
  )
};

export default DocumentItem;